export default "__VITE_ASSET__OQmQ$HKw__"